// ###########################################################################
// HEADER - Add class .min on scroll down
// Uniquement sur les pages avec un hero photo plein cadre (data-scroll-fx="1",
// voir templates/header.php) : sinon le header est deja rendu opaque cote
// serveur et ne doit pas redevenir transparent si on scroll tout en haut.
$(document).ready(function() {
  var $mainHeader = $('.main-header');

  if ($mainHeader.data('scroll-fx') != 1) {
    return;
  }

  function updateHeaderState() {
    // Add the 'min' class once the user has scrolled past 300 pixels.
    if ($(window).scrollTop() > 100) {
      $mainHeader.addClass('min');
    } else {
      $mainHeader.removeClass('min');
    }
  }

  $(window).on('scroll', updateHeaderState);

  // Au rechargement en cours de page, le navigateur restaure la position de
  // scroll sans declencher d'evenement "scroll" : on synchronise donc l'etat
  // du header des le chargement (et apres restauration eventuelle du scroll).
  updateHeaderState();
  $(window).on('load', updateHeaderState);
});

// ###########################################################################
// ANIMATION FADE TO TOP - element dom
var $animation_elements = $('.animated');
var $window = $(window);

function check_if_in_view() {
    var window_height = $window.height();
    var window_top_position = $window.scrollTop();
    var window_bottom_position = (window_top_position + window_height);

    $.each($animation_elements, function() {
        var $element = $(this);
        var element_height = $element.outerHeight();
        var element_top_position = $element.offset().top;
        var element_bottom_position = (element_top_position + element_height);

        //check to see if this current container is within viewport
        if ((element_bottom_position >= window_top_position) &&
            (element_top_position <= window_bottom_position)) {
            $element.addClass('active');
        }
        //else {
        //$element.removeClass('active');
        //}
    });
}

$window.on('scroll resize', check_if_in_view);
$window.trigger('scroll');

// ###########################################################################
// PRIMARY NAVIGATION
$("#btnMobile").click(function (e) {
  $(this).toggleClass("cross");
  $(".main-nav-wrapper").toggleClass("open");
  $("body").toggleClass("overflow");
});

// ###########################################################################
// SUBNAV NAVIGATION
$("ul > li.menu-item-has-children > a").click(function (e) {
    e.preventDefault();
    var LiParent =$(this).parent().attr('class');
    if(! LiParent.includes("openSub-menu") ){
        $('ul > li.menu-item-has-children > a').parent().removeClass("openSub-menu");
    }
    $(this).parent().toggleClass("openSub-menu");
});

// CLOSE NAV WHEN CLICK ANYWHERE
$(document).on("click", function (event) {
    var $trigger = $(".menu-item-has-children");
    if ($trigger !== event.target && !$trigger.has(event.target).length) {
        $(".menu-item-has-children").removeClass("openSub-menu");
    }
});

// ###########################################################################
// ANCRE
$('a[href^="#"]').on('click',function (e) {
    // Ignore les simples href="#" (boutons/dropdowns sans cible reelle) et
    // les onglets WooCommerce (fiche produit, .wc-tabs-wrapper/ul.tabs) : ces
    // liens partagent le meme href="#xxx" mais servent a switcher un panneau
    // sur place, pas a naviguer/scroller la page. WooCommerce simule lui-meme
    // un clic dessus au chargement si l'URL contient #tab-reviews (voir
    // woocommerce/assets/js/frontend/single-product.js) - sans cette
    // exclusion, ce clic simule declenchait aussi ce scroll anime, d'ou le
    // contenu qui "saute" a l'arrivee sur la page.
    if (this.hash === '#' || $(this).closest('.wc-tabs-wrapper, .woocommerce-tabs, ul.tabs').length) {
        return;
    }

    var target = this.hash,
    $target = $(target);

    if (!$target.length) {
        return;
    }

    e.preventDefault();

    var nav = $('nav');

    $('html, body').stop().animate({
        'scrollTop': $target.offset().top - nav.height()
    }, 1200, 'swing', function () {
        window.location.hash = target;
    });
});

// ###########################################################################
// SLICK - slideshow & slider
if (typeof $.fn.slick !== 'undefined') {
  $(document).ready(function(){

    $('.content-care .care-grid-wrapper .care-grid').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      infinite: true,
      cssEase: 'ease',
      fade: true,
      speed: 1000,
    });

  });
}
